import * as React from 'react';

import * as styles from './ModalFooter.css';

export const ModalFooter: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['modal-footer']}>{children}</div>;
};
